import { Chip } from '@mui/material';
import PropTypes from 'prop-types';
// Assets
import './UserStatus.css';

const UserStatus = ({ user }) => {
    if (user.is_disabled) {
        return <Chip label="Deactivated" className="user-status__chip user-status__chip-danger" />;
    }
    if (!user.is_verified) {
        return <Chip label="Invite Pending" className="user-status__chip user-status__chip-secondary" />;
    }
    if (!user.is_disabled) {
        return <Chip label="Active" className="user-status__chip user-status__chip-success" />;
    }

    return <Chip label="N/A" className="user-status__chip user-status__chip-secondary" />;
};

UserStatus.propTypes = {
    user: PropTypes.object.isRequired
};

export default UserStatus;
